import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Authority from "@/components/site/Authority";
import About from "@/components/site/About";
import Book from "@/components/site/Book";
import Consulting from "@/components/site/Consulting";
import Speaking from "@/components/site/Speaking";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  return (
    <main data-testid="home-page" className="relative">
      <Nav />
      <Hero />
      <Authority />
      <About />
      <Book />
      <Consulting />
      <Speaking />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
